<template>
  <div class="popup" v-cloak v-if="noticeShow">
      <div class="content" id="noticeRealTime">
            <div class="title">
                 {{$t('language.popup.taskListPopup.deleteTask')}}
                 <div class="icon white-close dialog-close" @click="noticeShow=false"></div>
            </div>
            <div class="notice-body">
                   <div class="notice-info">
                         {{$t('language.cloudSync.realTimeNotice')}}
                   </div>
                   <div class="realtime-notice-bottom">
                        <button style="width:110Px;marginRight:10Px;" @click.stop="runTasK()"> {{$t('language.common.ok')}}</button>
                        <button class="cancel-button" @click="noticeShow=false"> {{$t('language.twoStepverification.cancel')}}</button>
                   </div>
            </div>
      </div>
  </div>
</template>

<script>
export default {
    data:function(){
        return{
            noticeShow:false,
            isSure:false
        }
    },
    methods: {
        runTasK(){
           this.noticeShow=false;
           this.isSure=true;
           this.$parent.$refs.syncAimsDialog.syncAimSubmit();
            setTimeout(()=>{
           this.$parent.syncNow();
           },600);
        }

    },
    
}
</script>

<style>
#noticeRealTime{
    width: 550Px;
    height: 220Px;
}
.notice-body{
    width: 100%;
    height: 180Px;
    padding: 20Px 10Px 10Px 10Px;
    box-sizing: border-box;
    text-align: center;
  
}
.notice-info{
    width: 100%;
    height:100Px;
    float: left;
}
.realtime-notice-bottom{
    width: 528Px;
    height: 40Px;
    float: left;

}
</style>


// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/realtime_notice_popup.vue